<p-dialog [(visible)]="popupVisible" (visibleChange)="$event === true? '': onClose()" [modal]="true" [styleClass]="(popData.isDisbursed || popData.isValidating)?( (popData.icon? 'mismatch-dialog ':'') +'cus-dialog-lg cus-dialog dark-dialog no-exit'):'cus-dialog-md cus-dialog logout-dialog'" [draggable]="false" [resizable]="false">
  <div *ngIf="!popData.isDisbursed && !popData.isValidating" class="logout-inner">
    <div class="left">
      <img src="assets/images/logout_img.svg" alt="logout"/>
    </div>
    <div class="right">
      <div class="logout-title">{{ popData.title || 'Leave NorthernArc?'}}</div>
      <div class="logout-info">{{popData.text1 || 'Are you sure you'}} <span class="highlight">{{popData.text2 || 'want to logout ?'}}</span> <span class="logout-info">{{popData.text3 || ''}}</span></div>
      <div class="logout-action">
        <button class="btn-secondary" *ngIf="popData.showNoBtn" (click)="onClose()">{{ popData.noBtnTxt || 'No'}}</button>
        <button class="btn-primary" *ngIf="popData.showYesBtn" (click)="submit()">{{ popData.yesBtnTxt || 'Yes'}}</button>
      </div>
    </div>
  </div>
  <div *ngIf="popData.isValidating" class="dark-content">
    <div class="dark-inner">
      <div class="gradient-line"></div>
      <div class="dark-left">
        <img *ngIf="popData.icon" [src]="popData.icon || 'assets/images/dialog/dob_misMatch.png'" class="no-margin" alt="dob_misMatch"/>
        <ng-lottie *ngIf="!popData.icon" [options]="options"></ng-lottie> 
      </div>
      <div class="dark-right">
        <div class="dark-inn-title"><span class="highlight" [innerHTML]="popData.icon? popData.title: 'Validating,'">  </span> <span [ngClass]="{'wrap-text':!popData.icon}"> <span *ngIf="popData.icon" [innerHTML]="popData.text1"></span> {{popData.icon? '' : (popData.title.split(' ')[0]+'’s bank account')}}</span></div>
        <div class="dark-inn-info">
          
          <span  *ngIf="popData.icon" [innerHTML]="popData.text2"></span> {{popData.icon? '' :'This will take just a moment.'}} <span *ngIf="popData.icon" class="highlight" [innerHTML]="popData.text3"></span> <span *ngIf="popData.icon" [innerHTML]="popData.noBtnTxt"></span></div>
          <button class="btn-theme" *ngIf="popData.showYesBtn" (click)="submit()">{{ popData.yesBtnTxt || 'Yes'}}</button>
      </div>
    </div>
  </div>
<div *ngIf="popData.isDisbursed" class="dark-content success">
  <div class="dark-inner">
    <div class="gradient-line"></div>
    <div class="dark-left">
      <ng-lottie [options]="dISBURSEMENTMsg.message2?options: successOption"></ng-lottie> 
      <!-- <img src="assets/images/dialog/success_wish.svg" alt="Guardian Image" *ngIf="!dISBURSEMENTMsg.message2" /> -->
    </div>
    <div class="dark-right">
      <div class="dark-inn-title"><span class="highlight"> Hey {{applicant.applicantName.split(' ')[0]}}, </span><span class="wrap-text">{{dISBURSEMENTMsg.message1 || 'Funds Disbursed'}}</span></div>
      <div class="dark-inn-info"*ngIf="!dISBURSEMENTMsg.message2"> We have deposited {{ util.formator.format(loanDetails.amount)}} in the <span class="wrap-text">coaching center’s account.</span></div>
      <div class="dark-inn-info" *ngIf="dISBURSEMENTMsg.message2" [innerHTML]="dISBURSEMENTMsg.message2.replace('disbursement', '<strong class=disbursmentText>disbursement</strong>')"> </div>
    </div>
  </div>
</div>
</p-dialog>